import { MessageCircle } from 'lucide-react';
import { Button, type ButtonProps } from './ui/button';
import { useContactSupport } from '@/hooks/useContactSupport';

interface ContactSupportButtonProps extends Omit<ButtonProps, 'onClick'> {
  subject: string;
  fallbackEmail?: string;
  children?: React.ReactNode;
}

export function ContactSupportButton({
  subject,
  fallbackEmail,
  children = 'Contact Support',
  variant = 'outline',
  className,
  ...buttonProps
}: ContactSupportButtonProps) {
  const handleContactSupport = useContactSupport({
    subject,
    fallbackEmail,
  });

  return (
    <Button
      variant={variant}
      onClick={handleContactSupport}
      className={className}
      {...buttonProps}
    >
      <MessageCircle className="mr-2 h-4 w-4" />
      {children}
    </Button>
  );
}
